import { CreateStudySubmissionRequest } from '@app/models/StudySubmissionRequest.interface'
import { CreateStudySubmissionResponse } from '@app/models/StudySubmissionResponse.interface'
import { api } from '@cpms/common/helpers/api-axios'

const createStudySubmission = (payload: CreateStudySubmissionRequest) =>
  api.post<CreateStudySubmissionResponse>(`${process.env.REACT_APP_BASE_API_URL}/sim/v1/createstudysubmission`, payload)

export { createStudySubmission }
